// Evenimente GA4 (ecommerce) - funnel cf-extras
// REGULI: zero date personale (fără nume, email, telefon, CNP, adresă);
// se trimite DOAR dacă GA4 e încărcat, adică DOAR după acordul pentru cookie-uri „Statistici"
// (GoogleTracking.jsx încarcă gtag doar atunci). Fără consimțământ → nu se trimite nimic.

export const PRODUCT_NAMES = {
  carteFunciara: 'Extras Carte Funciară',
  planCadastral: 'Extras Plan Cadastral'
};

const round2 = (n) => Math.round(Number(n) * 100) / 100;

// Construiește un item GA4 pentru un tip de extras
export const buildItem = (certificateType, price, variant = 'Standard') => ({
  item_id: certificateType === 'carteFunciara' ? 'CF' : 'PC',
  item_name: PRODUCT_NAMES[certificateType] || 'Extras',
  item_category: 'Extras',
  item_variant: variant,
  price: round2(price) || 0,
  quantity: 1
});

// Trimite un eveniment GA4 (no-op dacă gtag nu e încărcat = fără consimțământ)
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, params);
    return true;
  } catch (e) {
    return false;
  }
};

// Așteaptă încărcarea gtag (după consimțământ) - max `timeoutMs`
export const waitForGtag = (timeoutMs = 10000) =>
  new Promise((resolve) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') return resolve(true);
    const start = Date.now();
    const timer = setInterval(() => {
      if (typeof window.gtag === 'function') { clearInterval(timer); resolve(true); }
      else if (Date.now() - start > timeoutMs) { clearInterval(timer); resolve(false); }
    }, 300);
  });
